import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import StripeElementsProvider from '@/components/purchase/StripeElementsProvider';
import CheckoutForm from '@/components/upsellLanding/CheckoutForm';
import Upsell from '@/components/upsellLanding/Upsell';
import useQueryParams from '@/hooks/utils/useQueryParams';
import { useRouterPush } from '@/hooks/utils/useRouterPush';
import getParamAsString from '@/utils/getParamsAsString';

import { Wrapper } from './styles';

type UpsellLandingWrapperProps = {
	bgImg: string;
	isCheckoutSessionsEnabled?: boolean;
};

const UpsellLandingWrapper = ({ bgImg, isCheckoutSessionsEnabled }: UpsellLandingWrapperProps) => {
	/*
    During initial JS hydration, Next (v9.5) does not provide any query parameters on the router
    So, we instead pull the query off of the window.location and parse it ourselves.
    We only do this for the email param, so that we can initialize the fields properly
  */
	const query = useQueryParams();
	const email = getParamAsString(query.email);
	const routerPush = useRouterPush();

	async function onPurchaseSuccess() {
		await routerPush('/premium-confirmation');
	}

	return (
		<Wrapper id={MAIN_CONTENT_ID}>
			<StripeElementsProvider isStripeNext>
				<Upsell bgImg={bgImg} />
				<CheckoutForm
					email={email}
					isCheckoutSessionsEnabled={isCheckoutSessionsEnabled}
					onPurchaseSuccess={onPurchaseSuccess}
				/>
			</StripeElementsProvider>
		</Wrapper>
	);
};

export default UpsellLandingWrapper;
